import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlinedFlag, MdOutlineEventSeat } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Pick Your Show(s)",
    description: "Select 1 or more shows to get started.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Log into your Ticketmaster Account",
    description:
      "Connect to your Ticketmaster account using the secure Ticketmaster Login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: (
      <>
        Choose from available premium seating options, such as exclusive box
        seats and suites.
        <br />
        <b>
          <u>Please Note:</u> Some seating options presented may be within
          shared spaces. If the seats you select do not make up an entire box or
          suite, the remaining seats may be sold to other parties. This will be
          more likely when purchasing seats in pairs.
        </b>
      </>
    ),
  },
  {
    icon: <HiOutlineTicket />,
    title: "Access Your Tickets",
    description: (
      <>
        Tickets will be available in your Ticketmaster Account Manager after
        purchase. Your venue's dedicated Account Representative will introduce
        themselves to you via email or phone in the days following your
        purchase. They will be happy to answer any additional questions you may
        have. If you have questions in the meantime, please reach out to{" "}
        <Link
          target="_blank"
          href="mailto:premiumtickets@livenation.com"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          premiumtickets@livenation.com
        </Link>
        .
      </>
    ),
  },
];

export const faqs = [
  {
    title: "What if I don't already have a Ticketmaster Account?",
    description:
      "You'll be prompted to create an account if you don't already have one. It only takes a moment!",
  },
  {
    title: "What are premium seats?",
    description:
      "These are our most exclusive locations - such as box seats and suites - that include awesome views, in-seat waitstaff, and elevated food and beverage offerings available for purchase",
  },
  {
    title: "Is seating assigned within each box or suite?",
    description:
      "Seating within each box and suite is unassigned. You may sit in any available seat within the box or suite section purchased.",
  },
  {
    title: "Do these tickets include parking or club access?",
    description: (
      <>
        General admission parking comes with your ticket. Upgrades such as premium parking options and club access may be available to purchase separately via{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://www.ticketmaster.com/the-pavilion-at-montage-mountain-tickets-scranton/venue/16765?addOnType=CLUB_ACCESS"
        >
          Ticketmaster
        </Link>.
      </>
    ),
  },
  {
    title: "Can I transfer these tickets to my friends and family?",
    description:
      "You may transfer tickets to others via the Account Manager platform. Please note that in limited circumstances, tickets may be subject to transfer restrictions at the request of the artist.",
  },
  {
    title: "How do I find my tickets?",
    description:
      "Tickets will be available in your Ticketmaster Account Manager account after purchase. Simply sign in with the same account as you did to place your order.",
  },
  {
    title: "How do I use my tickets?",
    description: (
      <>
        Tickets can be added to a mobile wallet (Apple Wallet on iOS or Google
        Wallet on Android devices) or viewed within the Live Nation app. Tickets
        added to mobile wallets utilize Tap to Enter technology - no barcode
        necessary!
        <br />
        We recommend adding tickets to your mobile wallet in advance of arriving
        at the venue to ensure a seamless entry experience.
      </>
    ),
  },
  {
    title: "Is there someone I can reach out to with questions?",
    description:
      "Your dedicated Account Representative will introduce themselves to you via email or phone in the days following your purchase. They will be happy to answer any additional questions you may have.",
  },
  {
    title:
      "Can I return or exchange tickets for a show I can no longer attend?",
    description:
      "Due to the nature of live events, ticket purchases are final.",
  },
  {
    title: "What happens if a show I selected cancels?",
    description:
      "If a show is canceled, your Account Representative will work with you to select another show within the 2026 concert season. If another show is not available or selected, we will issue a refund in accordance with the Live Nation Premium Seat Program Terms & Conditions governing your purchase.",
  },
];
